import React from 'react';
import { Globe, Lock, Heart, Users, LayoutGrid } from 'lucide-react';

const FILTER_OPTIONS = [
    { value: 'todos',      label: 'Todos',      Icon: LayoutGrid },
    { value: 'publicos',   label: 'Públicos',   Icon: Globe },
    { value: 'personales', label: 'Personales', Icon: Lock },
    { value: 'favoritos',  label: 'Favoritos',  Icon: Heart },
    { value: 'amigos',     label: 'Amigos',     Icon: Users },
];

const FiltrosExplorador = ({ value = 'todos', onChange }) => {
    return (
        <div className="flex flex-wrap gap-1.5">
            {FILTER_OPTIONS.map(({ value: optValue, label, Icon }) => {
                const isActive = value === optValue;
                return (
                    <button
                        key={optValue}
                        onClick={() => onChange(optValue)}
                        className={`btn btn-xs gap-1.5 transition-all duration-150 ${
                            isActive
                                ? 'btn-primary shadow-sm'
                                : 'btn-ghost opacity-70 hover:opacity-100'
                        }`}
                    >
                        <Icon className="w-3 h-3" />
                        {label}
                    </button>
                );
            })}
        </div>
    );
};

export default FiltrosExplorador;
